import React from 'react';
import Panel from './Panel';
import { StyleSheet, css } from 'aphrodite/no-important';
import { CENTER, BASE_SPACING } from '../styles';

const s = StyleSheet.create({
  root: {
    position: 'fixed',
    display: 'flex',
    alignItems: CENTER,
    justifyContent: CENTER,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    backgroundColor: 'rgba(0,0,0,.1)',
    zIndex: 100,
    paddingTop: 20,
    paddingBottom: 20,
  },
  body: {
    flexDirection: 'column',
    width: 500,
    maxWidth: '80%',
    maxHeight: '100%',
    overflowY: 'auto',
    padding: BASE_SPACING,
  },
});

const Popup = (props) => (
  <div className={css(s.root)}>
    <Panel {...props} __className={s.body} />
  </div>
);

export default Popup;
